/* gr-subscribe.js
 *
 * Wiring for the Subscribe configurator.
 * - Syncs the size chip set to the currently selected roast's variants.
 * - Resolves the active variant by matching option1 (size) — extend
 *   matching logic if you add grind as option2.
 * - Applies 15% discount to the displayed price (visual only). Real
 *   discount must be configured on the selling plan in Shopify
 *   Subscriptions so checkout honors it.
 * - Submits to /cart/add.js with selling_plan = selected frequency block.
 */
(function () {
  const root = document.querySelector('[data-gr-sub-form]');
  if (!root) return;
  const section = root.closest('.gr-sub');

  const state = {
    product: null,
    variantId: null,
    size: null,
    freq: section.dataset.defaultFrequency || '4w',
    planId: null,
  };

  const $ = (sel, ctx) => (ctx || root).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || root).querySelectorAll(sel));

  const fmt = (cents) => '$' + (cents / 100).toFixed(2);

  function setActive(group, el) {
    $$('[' + group + ']', section).forEach((b) => {
      b.classList.toggle('is-active', b === el);
      b.setAttribute('aria-checked', b === el ? 'true' : 'false');
    });
  }

  // FR/EN alias matching for option images
  var GRIND_GROUPS = ['grind type','grind','type de mouture','mouture'];
  var SIZE_GROUPS = ['size','taille','format','bag size'];
  var WB_VALS = ['whole bean','en grain','en grains','grains'];
  var GR_VALS = ['ground','moulu','moulue'];
  var S12_VALS = ['12 oz','12oz','340 g','340g'];
  var S2_VALS = ['2 lbs','2 lb','2lbs','907 g','907g'];

  function matchAlias(arr, val) {
    return arr.indexOf(val.toLowerCase().trim()) !== -1;
  }

  function findOptionImage(optionImages, optName, value) {
    if (!optionImages || !optionImages.length) return null;
    var optLow = optName.toLowerCase().trim();
    var valLow = value.toLowerCase().trim();

    for (var i = 0; i < optionImages.length; i++) {
      var oi = optionImages[i];
      if (!oi.image) continue;
      var gLow = (oi.group || '').toLowerCase().trim();
      var vLow = (oi.value || '').toLowerCase().trim();

      // Match group
      var gMatch = gLow === optLow;
      if (!gMatch && matchAlias(GRIND_GROUPS, gLow) && matchAlias(GRIND_GROUPS, optLow)) gMatch = true;
      if (!gMatch && matchAlias(SIZE_GROUPS, gLow) && matchAlias(SIZE_GROUPS, optLow)) gMatch = true;
      if (!gMatch) continue;

      // Match value
      var vMatch = vLow === valLow;
      if (!vMatch && matchAlias(WB_VALS, vLow) && matchAlias(WB_VALS, valLow)) vMatch = true;
      if (!vMatch && matchAlias(GR_VALS, vLow) && matchAlias(GR_VALS, valLow)) vMatch = true;
      if (!vMatch && matchAlias(S12_VALS, vLow) && matchAlias(S12_VALS, valLow)) vMatch = true;
      if (!vMatch && matchAlias(S2_VALS, vLow) && matchAlias(S2_VALS, valLow)) vMatch = true;
      if (vMatch) return oi.image;
    }
    return null;
  }

  function renderOptions() {
    const host = $('[data-gr-sub-options]');
    host.textContent = '';
    const product = state.product;
    if (!product || !product.options || !product.variants) {
      host.textContent = 'No variants.';
      return;
    }

    // Initialize selected options from first available variant
    if (!state.selectedOptions) state.selectedOptions = {};
    var firstAvail = product.variants.find(function(v) { return v.available; }) || product.variants[0];
    product.options.forEach(function(optName, i) {
      if (!state.selectedOptions[optName]) {
        state.selectedOptions[optName] = firstAvail ? (firstAvail['option' + (i + 1)] || '') : '';
      }
    });

    // Render each option group
    product.options.forEach(function(optName, optIdx) {
      var block = document.createElement('div');
      block.className = 'gr-sub__block';

      var lbl = document.createElement('div');
      lbl.className = 'gr-sub__lbl';
      lbl.textContent = optName.toUpperCase();
      block.appendChild(lbl);

      var chips = document.createElement('div');
      chips.className = 'gr-pdp__option-chips';
      chips.setAttribute('role', 'radiogroup');

      // Collect unique values for this option
      var seen = {};
      var isSize = matchAlias(SIZE_GROUPS, optName);
      product.variants.forEach(function(v) {
        var val = v['option' + (optIdx + 1)];
        if (val && !seen[val]) {
          seen[val] = true;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'gr-pdp__chip' + (isSize ? ' gr-pdp__chip--size' : '');
          btn.setAttribute('role', 'radio');
          btn.dataset.optionName = optName;
          btn.dataset.optionValue = val;

          // Find option image
          var imgUrl = findOptionImage(state.optionImages, optName, val);
          if (imgUrl) {
            btn.classList.add('gr-pdp__chip--has-img');
            var imgSpan = document.createElement('span');
            imgSpan.className = 'gr-pdp__chip-img';
            var img = document.createElement('img');
            img.src = imgUrl;
            img.alt = val;
            img.width = 40;
            img.height = 40;
            img.loading = 'lazy';
            imgSpan.appendChild(img);
            btn.appendChild(imgSpan);
          }

          var labelSpan = document.createElement('span');
          labelSpan.className = 'gr-pdp__chip-label';
          var weightSpan = document.createElement('span');
          weightSpan.className = 'gr-pdp__chip-weight';
          weightSpan.textContent = val.toUpperCase();
          labelSpan.appendChild(weightSpan);

          // Show price on size chips
          if (isSize) {
            var sizeVariant = product.variants.find(function(sv) {
              return sv['option' + (optIdx + 1)] === val && sv.available;
            });
            if (sizeVariant) {
              var priceSpan = document.createElement('span');
              priceSpan.className = 'gr-pdp__chip-price';
              priceSpan.textContent = fmt(sizeVariant.price);
              labelSpan.appendChild(priceSpan);
            }
          }

          btn.appendChild(labelSpan);

          if (val === state.selectedOptions[optName]) {
            btn.classList.add('is-active');
          }

          btn.addEventListener('click', function() {
            state.selectedOptions[optName] = val;
            chips.querySelectorAll('.gr-pdp__chip').forEach(function(b) {
              b.classList.toggle('is-active', b === btn);
            });
            resolveVariant();
            updatePrice();
          });

          chips.appendChild(btn);
        }
      });

      block.appendChild(chips);
      host.appendChild(block);
    });

    resolveVariant();
  }

  function resolveVariant() {
    var product = state.product;
    if (!product || !product.variants) return;
    var match = product.variants.find(function(v) {
      return product.options.every(function(optName, i) {
        return v['option' + (i + 1)] === state.selectedOptions[optName];
      });
    });
    if (match) {
      state.variantId = match.id;
    } else {
      // Fallback to first available
      var fallback = product.variants.find(function(v) { return v.available; });
      if (fallback) state.variantId = fallback.id;
    }
  }

  function updatePrice() {
    const v = (state.product.variants || []).find((x) => x.id === state.variantId) || state.product.variants[0];
    if (!v) return;
    const base = v.price; // cents
    const sub = Math.round(base * 0.85);
    $('[data-gr-sub-price-old]').textContent = fmt(base);
    $('[data-gr-sub-price-new]').textContent = fmt(sub);
    var titleEl = $('[data-gr-sub-title]');
    $('[data-gr-sub-title]').textContent = (titleEl.dataset.startFrom || 'START FROM') + ' ' + fmt(sub);
  }

  function pickRoast(btn) {
    setActive('data-gr-sub-roast', btn);
    try {
      state.product = JSON.parse(btn.dataset.product);
    } catch (e) {
      console.error('[gr-subscribe] could not parse product JSON', e);
      return;
    }
    try {
      state.optionImages = JSON.parse(btn.dataset.optionImages || '[]');
    } catch (e) {
      state.optionImages = [];
    }
    renderOptions();
    updatePrice();
    resolveSellingPlan();
  }

  function resolveSellingPlan() {
    // Find the active roast button and its selling plans
    var activeRoast = $('[data-gr-sub-roast].is-active', section);
    if (!activeRoast || !activeRoast.dataset.sellingPlans) { state.planId = null; return; }

    // Find the active frequency button's label
    var activeFreq = $('[data-gr-sub-freq].is-active', section);
    if (!activeFreq) { state.planId = null; return; }
    var freqLabel = activeFreq.querySelector('.gr-sub__freq-l');
    var freqName = freqLabel ? freqLabel.textContent.trim().toLowerCase() : '';

    // Match frequency name against product's selling plans
    var plans = activeRoast.dataset.sellingPlans.split(',');
    state.planId = null;
    for (var i = 0; i < plans.length; i++) {
      var parts = plans[i].trim().split(':');
      if (parts.length === 2 && freqName.toLowerCase().includes(parts[0].trim())) {
        state.planId = parts[1].trim();
        break;
      }
    }
  }

  function pickFreq(btn) {
    setActive('data-gr-sub-freq', btn);
    state.freq = btn.dataset.value;
    resolveSellingPlan();
  }

  async function submit(e) {
    e.preventDefault();
    const cta = $('[data-gr-sub-submit]');
    const err = $('[data-gr-sub-err]');
    err.hidden = true;
    if (!state.variantId) {
      err.textContent = 'Pick a roast and size to continue.';
      err.hidden = false;
      return;
    }
    if (!state.planId) {
      err.textContent = 'Subscription plan is not configured. Set a selling plan ID on this frequency in Theme Editor.';
      err.hidden = false;
      return;
    }

    cta.disabled = true;
    cta.textContent = 'ADDING…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: state.variantId, quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1, selling_plan: Number(state.planId) }],
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
      // Notify any cart drawer listeners.
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { source: 'subscribe' } }));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.dispatchEvent(new CustomEvent('gr:cart:open'));
      cta.textContent = 'ADDED!';
      setTimeout(function () {
        cta.disabled = false;
        cta.textContent = 'START SUBSCRIPTION';
      }, 1500);
    } catch (e2) {
      err.textContent = e2.message;
      err.hidden = false;
      cta.disabled = false;
      cta.innerHTML = 'START SUBSCRIPTION <svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true"><path d="M1 5h11m-4-4 4 4-4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
  }

  // Qty buttons
  var qtyInput = $('[data-gr-sub-qty]');
  $$('[data-gr-sub-qty-delta]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (!qtyInput) return;
      var val = parseInt(qtyInput.value, 10) || 1;
      var delta = parseInt(btn.dataset.grSubQtyDelta, 10);
      var next = Math.max(1, Math.min(10, val + delta));
      qtyInput.value = next;
    });
  });

  // Init
  $$('[data-gr-sub-roast]').forEach((btn) => btn.addEventListener('click', () => pickRoast(btn)));
  $$('[data-gr-sub-freq]').forEach((btn) => btn.addEventListener('click', () => pickFreq(btn)));
  root.addEventListener('submit', submit);

  const firstRoast = $('[data-gr-sub-roast]');
  if (firstRoast) pickRoast(firstRoast);
  const defaultFreq = $$('[data-gr-sub-freq]').find((b) => b.classList.contains('is-active')) || $('[data-gr-sub-freq]');
  if (defaultFreq) pickFreq(defaultFreq);
})();
